export enum IconType {
  None = '',
  Coffee = 'pi pi-coffee',
  Camera = 'pi pi-video',
  ArrowRight = 'pi pi-angle-right',
  ArrowLeft = 'pi pi-angle-left',
  ArrowDown = 'pi pi-angle-down',
  ArrowUp = 'pi pi-angle-up',
  Bars = 'pi pi-bars',
  Logout = 'pi pi-sign-out',
  Question = 'pi pi-question',
  CircleQuestion = 'pi pi-question-circle',
  LineChart = 'pi pi-chart-line',
  BarChart = 'pi pi-chart-bar',
  Tags = 'pi pi-tags',
  Calendar = 'pi pi-calendar',
  Search = 'pi pi-search',
  Xmark = 'pi pi-times',
  Download = 'pi pi-download',
  Filter = 'pi pi-filter',
  Upload = 'pi pi-upload',
  Pencil = 'pi pi-pencil',
  Clock = 'pi pi-clock',
  Cog = 'pi pi-cog',
  EyeSlash = 'pi pi-eye-slash',
  Copy = 'pi pi-copy',
  Plus = 'pi pi-plus',
  Lock = 'pi pi-lock',
  Unlock = 'pi pi-unlock',
  Circle = 'pi pi-circle',
  Hashtag = 'pi pi-hashtag',
  Sitemap = 'pi pi-sitemap',
  Laptop = 'pi pi-desktop',
  File = 'pi pi-file',
  Microphone = 'pi pi-microphone',
  Link = 'pi pi-link',
  Comments = 'pi pi-comments',
  ShareNodes = 'pi pi-share-alt',
  BoxArchive = 'pi pi-box',
  Book = 'pi pi-book',
  Key = 'pi pi-key',
  Trash = 'pi pi-trash',
  Send = 'pi pi-send',
  AddUser = 'pi pi-user-plus',
  RemoveUser = 'pi pi-user-minus',
  Folder = 'pi pi-folder',
  ChevronUp = 'pi pi-chevron-up',
  ChevronDown = 'pi pi-chevron-down',
  Envelope = 'pi pi-envelope',
  Users = 'pi pi-users',
  LocationPin = 'pi pi-map-marker',
  Mobile = 'pi pi-mobile',
  Comment = 'pi pi-comment',
  Lightbulb = 'pi pi-lightbulb',
  Refresh = 'pi pi-refresh',
  RotateRight = 'pi pi-replay',
  Building = 'pi pi-building',
  House = 'pi pi-home',
  Check = 'pi pi-check',
  FilePdf = 'pi pi-file-pdf',
  MinusCircle = 'pi pi-minus-circle',
  FilledCircle = 'pi pi-circle-fill',
  User = 'pi pi-user',
  ExclamationTriangle = 'pi pi-exclamation-triangle',
  Expand = 'pi pi-arrow-up-right-and-arrow-down-left-from-center',
  Collapse = 'pi pi-arrow-down-left-and-arrow-up-right-to-center',
  Wrench = 'pi pi-wrench',
  Images = 'pi pi-images',
  VolumeUp = 'pi pi-volume-up',
  InfoCircle = 'pi pi-info-circle',
  CheckCircle = 'pi pi-check-circle',
  Bolt = 'pi pi-bolt',
}
